<template>
        <nav class="d-none d-md-block bg-light sidebar p-1">
            <div class="sidebar-sticky">
                <ul class="nav" v-if="menus && menus.length">
                    <li class="nav-item pr-2 ml-1 text-center menu-item" v-for="menu of menus" :key="menu.ba06_id">
                        <div @click="registraMenu(menu.ba06_url, menu.ba06_id)" class="borda nav-link" :title="menu.ba06_nome" :data-id="menu.ba06_id">
                            <span data-feather="file"></span>
                            <i :class="menu.ba06_icone"></i>
                        </div>
                        <p class="mt-1 ml-2 text-menu">{{menu.ba06_nome}}</p>
                    </li>
                </ul>
            </div>
        </nav>
</template>

<script>
    export default {
        name: 'Menu',

        data() {
            return {
                menus: ''
            }
        },

        methods: {
            configuraMenuAtivo(){
                let menus = $('.borda');
                for(var i = 0; i < menus.length; i++){
                    if($(menus[i]).attr('data-id') == store.state.global.menuAtual){
                        $('.borda').css('background', '#88a5b0');
                        $(menus[i]).css('background', '#18a689');
                    }
                } 
            },
            registraMenu(url, idMenu){
                store.dispatch('configurarMenuAtual', idMenu)
                this.configuraMenuAtivo()
                this.$router.push(url)
            }
        },
        updated() {
            this.configuraMenuAtivo()
        },

        mounted() {
            let thisVue = this;
            api.enviarRequisicao('get', '/api/controleacesso/menus/sistema/'+store.state.global.sistemas['contas_consumo']).then( function (response) {
                    thisVue.menus = response.data;
                    let menus = {};

                    for(let i = 0; i < thisVue.menus.length; i++){
                        menus[thisVue.menus[i].ba06_id] = thisVue.menus[i].menuInterno;
                    }

                    store.dispatch('configurarMenus', menus);
                });

            $(document).ready(function () {
                $('.menu-btn').on('click', function () {
                    $('.sidebar').toggleClass('active');
                    $('.menu-btn').toggleClass('active');
                })
            });
        }
    }
</script>

<style scoped>
    .borda {
        width: 70px;
        background-color: #88a5b0;
        border-radius: 5px;
        padding: 12px 5px;
        cursor: pointer;
    }

    p {
        color: #fff;
    }

    i {
        font-size: 50px;
    }

    .borda:hover {
        background-color: #18a689;
        color: #fff;
        border: none;
    }

    .sidebar {
        background-color: #161e37 !important;
        min-height: 100vh;
        width: 285px;
        transition: all 0.3s;
    }

    .sidebar div{
        margin-left: 7px;
    }

    .sidebar.active {
        margin-left: -215px;
    }

    .sidebar.active li{
        width: 100%;
    }

    .sidebar.active li i{
        font-size: 25px;
    }

    .sidebar.active li p{
        display: none;
        margin-top: 5px!important;
    }

    .sidebar.active li div{
        width: 50px;
        float: right;
        margin: 10px 0;
    }

    .sidebar.active li>div{
        float: right;
        font-size: 9px;
    }


    ul {
        margin-top: 20px;
    }

    li .active {
        background-color: #18a689;
    }

    .menu-item{
        width: 85px;
        overflow: hidden;
        color: #fff;
    }

    .text-menu{
        font-size: 12px;
    }
</style>
